import gql from "graphql-tag";

export default gql`query BillTemplate($id:Int!) {
    billTemplate(id:$id) {
        id    
        archived   
        category {
            id
            name
        } 
        templateMonies {
          id
          name
          paidreceived
          templateSections {
            id
            name
            vat
            nosubtotal
            label
            archived
            templateEntries {
              id
              name
              value
              entrytype
              discount
              archived
              includedByDefault
              entryCount
              description {
                  id
                  body
              }
            }
          }
        }
      }
  }`